export const businessCategories = [
    'Restaurants',
    'Bars and Pubs',
    'Florists',
    'General Goods',
    'Cafe and Coffee Shops',
    'Hardware Stores',
    'Entertainment',
    'Other',
]